export default [
  {
    path: "/wx",
    name:'app-index',
    meta: {
      title: "首页"
    },
    component: () => import(/* webpackChunkName: "nav" */ "./wx")
  },
  {
    path: "*",
    component: () => import(/* webpackChunkName: "404" */ "./404")
  }
];
